import {VARIANTS} from "@ui-seeker/core";

const overrideTableStyles = theme => ({
  MuiTableCell: {
    styleOverrides: {
      head: {
        color: theme.palette.text.secondary,
        fontWeight: 'normal'
      }
    }
  }
})

export default overrideTableStyles